export enum StatistiquesPath{
    BPF = 'bpf',
    FINANCIER = 'financier',
    PARTICIPANT = 'participant',
    FORMATEUR = 'formateur',
    QUALITY = 'qualite',
    SESSION = 'session',
    COMMERCIAL = 'commercial'
}
